<template>
	<n-popover
		trigger="manual"
		:show="showPopover"
		placement="bottom"
		:z-index="0"
		:theme-overrides="{
			color: 'var(--season-color)',
			textColor: '#fff',
		}"
	>
		<div>
			<div class="float-right flex mb-2">
				<n-button text @click="showPopover = false">
					<template #icon>
						<n-icon class="text-white" size="22"><i-carbon-close /></n-icon>
					</template>
				</n-button>
			</div>
			<div class="pt-2 cursor-pointer" @click="handlePopoverClick">
				<n-text class="block text-white/90">
					{{ t$.popover_title.replace('%%MINISITE_NAME%%', minisite.name) }}
				</n-text>
				<n-text class="block text-white text-lg font-medium">{{ t$.popover_subtitle }}</n-text>
			</div>
		</div>
		<template #trigger>
			<div class="flex flex-col items-center gap-2 p-3">
				<n-text type="primary" class="font-bold uppercase leading-tight">
					{{ t$.title }}
				</n-text>
				<div class="flex gap-2">
					<div ref="datepickerDaterangeRef" class="datepicker-daterange w-full">
						<n-date-picker
							v-model:value="fields.arrival_departure"
							type="daterange"
							:first-day-of-week="0"
							format="do MMM yyyy"
							:is-date-disabled="date => date < DateTime.now().startOf('day')"
							close-on-select
							input-readonly
							:actions="null"
							:to="datepickerDaterangeRef"
							bind-calendar-months
							placement="bottom"
							class="w-full"
							@update:value="handleUpdate"
						/>
					</div>
					<n-button type="info" @click="handleUpdate">
						<template #icon>
							<n-icon><i-carbon-arrow-right /></n-icon>
						</template>
					</n-button>
				</div>
			</div>
		</template>
	</n-popover>
	<n-modal v-model:show="showModal" preset="card" class="w-[668px] max-w-[calc(100vw_-_16px)] my-5">
		<the-form :minisite="minisite" :lang="lang" />
	</n-modal>
</template>

<script setup>
	import {NPopover, NText, NButton, NModal, NIcon, NDatePicker} from 'naive-ui'
	import {DateTime} from 'luxon'
	import {merge} from 'lodash-es'
	import TheForm from '../asiagoit-forms/TheForm.vue'
	import ICarbonArrowRight from '~icons/carbon/arrow-right'
	import ICarbonClose from '~icons/carbon/close'
	import {getTranslations} from './translations'
	import {loadUserData, saveUserData} from '../asiagoit-forms/storage'
	import {ref, toRefs} from 'vue'

	const props = defineProps({
		minisite: Object,
		lang: String,
	})
	const {minisite, lang} = toRefs(props)

	const t$ = getTranslations(lang.value === 'en' ? 2 : lang.value === 'de' ? 3 : 1)
	const showModal = ref(false)
	const showPopover = ref(false)
	const datepickerDaterangeRef = ref()
	const fields = ref(
		generateModel({
			arrival_departure: null,
		})
	)

	function generateModel(fields) {
		const data = loadUserData()
		return merge(fields, data.fields)
	}

	function handleUpdate() {
		saveUserData(fields.value)
		showModal.value = true
	}

	setTimeout(() => {
		showPopover.value = true
	}, 15_000)

	function handlePopoverClick() {
		showPopover.value = false
		showModal.value = true
	}
</script>

<style lang="scss" scoped>
	.datepicker-daterange,
	.datepicker-date {
		:deep(.n-date-panel .n-date-panel-calendar--end) {
			@apply hidden min-[480px]:block;
		}
	}

	:deep(.n-date-panel .n-date-panel-month .n-date-panel-month__fast-prev),
	:deep(.n-date-panel .n-date-panel-month .n-date-panel-month__fast-next) {
		@apply hidden;
	}

	:deep(.n-date-panel .n-date-panel-month .n-date-panel-month__prev),
	:deep(.n-date-panel .n-date-panel-month .n-date-panel-month__next) {
		@apply col-span-2;
	}
</style>
